// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.handler.search.dto.HpSearchFlag

export enum HpSearchFlag {
  ACCEPTING_APPLICATIONS = 'acceptingApplications',
  AIR_CONDITIONING = 'airConditioning',
  ALLOWS_CATS = 'allowsCats',
  ALLOWS_DOGS = 'allowsDogs',
  APARTMENT = 'apartment',
  BASEMENT = 'basement',
  CONDO = 'condo',
  CORPORATE_HOUSING = 'corporateHousing',
  DISHWASHER = 'dishwasher',
  DOORMAN = 'doorman',
  DUPLEX = 'duplex',
  ELEVATOR = 'elevator',
  EV_CHARGER = 'evCharger',
  FITNESS_CENTER = 'fitnessCenter',
  FURNISHED = 'furnished',
  GATED_ENTRY = 'gatedEntry',
  HEATING = 'heating',
  HIGH_SPEED_INTERNET = 'highSpeedInternet',
  HOUSE = 'house',
  INCOME_RESTRICTED = 'incomeRestricted',
  LAUNDRY = 'laundry',
  LAUNDRY_IN_UNIT = 'laundryInUnit',
  LAUNDRY_SHARED = 'laundryShared',
  LISTED_BY_OWNER = 'listedByOwner',
  MILITARY_HOUSING = 'militaryHousing',
  PARKING = 'parking',
  PHOTOS = 'photos',
  POOL = 'pool',
  PRICE = 'price',
  ROOM_FOR_RENT = 'roomForRent',
  SENIOR_HOUSING = 'seniorHousing',
  SPECIAL_OFFERS = 'specialOffers',
  STANDARD_RENTAL = 'standardRental',
  STUDENT_HOUSING = 'studentHousing',
  SUBLET = 'sublet',
  TOWNHOUSE = 'townhouse',
}

export const HpSearchFlag_values = [
  HpSearchFlag.ACCEPTING_APPLICATIONS,
  HpSearchFlag.AIR_CONDITIONING,
  HpSearchFlag.ALLOWS_CATS,
  HpSearchFlag.ALLOWS_DOGS,
  HpSearchFlag.APARTMENT,
  HpSearchFlag.BASEMENT,
  HpSearchFlag.CONDO,
  HpSearchFlag.CORPORATE_HOUSING,
  HpSearchFlag.DISHWASHER,
  HpSearchFlag.DOORMAN,
  HpSearchFlag.DUPLEX,
  HpSearchFlag.ELEVATOR,
  HpSearchFlag.EV_CHARGER,
  HpSearchFlag.FITNESS_CENTER,
  HpSearchFlag.FURNISHED,
  HpSearchFlag.GATED_ENTRY,
  HpSearchFlag.HEATING,
  HpSearchFlag.HIGH_SPEED_INTERNET,
  HpSearchFlag.HOUSE,
  HpSearchFlag.INCOME_RESTRICTED,
  HpSearchFlag.LAUNDRY,
  HpSearchFlag.LAUNDRY_IN_UNIT,
  HpSearchFlag.LAUNDRY_SHARED,
  HpSearchFlag.LISTED_BY_OWNER,
  HpSearchFlag.MILITARY_HOUSING,
  HpSearchFlag.PARKING,
  HpSearchFlag.PHOTOS,
  HpSearchFlag.POOL,
  HpSearchFlag.PRICE,
  HpSearchFlag.ROOM_FOR_RENT,
  HpSearchFlag.SENIOR_HOUSING,
  HpSearchFlag.SPECIAL_OFFERS,
  HpSearchFlag.STANDARD_RENTAL,
  HpSearchFlag.STUDENT_HOUSING,
  HpSearchFlag.SUBLET,
  HpSearchFlag.TOWNHOUSE,
] as const;
